import Vue from 'vue';
import productTransformer from './../../transformers/product';

const success = (resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(productTransformer.fetch(errors));
};

export default (id, product) => {
  const data = new FormData();
  Object.keys(product).map((k) => {
    data.append(k, product[k]);
    return null;
  });
  return new Promise((resolve, reject) => {
    Vue.$http
      .request({
        url: `/products/${id}`,
        data,
        method: 'post',
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(() => {
        success(resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  });
};



// WEBPACK FOOTER //
// ./src/app/services/product/update.js